import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./components/common/ConfirmModal/confirm-modal.style.scss";
import "./index.css";

const container = document.getElementById("root") as Element;
const root = createRoot(container);

root.render(
  <div className="App">
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </div>
);
